import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    display: 'grid',
    gridTemplateColumns: '5fr 4fr',
    gridColumnGap: '24px',
    cursor: 'pointer',

    '@media(max-width: 600px)': {
      gridTemplateColumns: '1fr',
      gridRowGap: '30px',
    }
  },

  modal: {
    maxWidth: '736px',
  },

  inputContainer: {
    position: 'relative',
    cursor: 'pointer',
    '& *': {
      cursor: ['pointer', '!important'],
    },
  },
});
